module.exports = __webpack_public_path__ + "img/ic-fb-login.9e11a0c9.svg";